import { Navigate, Route, Routes } from "react-router-dom";
import React from "react";
// import Home from "./pages/Home";
// import Pricing from "./pages/Pricing";
// import Login from "./pages/Login";
// import Signup from "./pages/Signup";
// import Dashboard from "./pages/Dashboard";
// import Purchase from "./pages/Purchase";
// import FAQ from "./pages/FAQ";
// import NotFound from "./pages/NotFound";
// import CourseContent from "./pages/CourseContent";
// import Admin from "./pages/Admin";
// import About from "./pages/About";
// import PrivacyPolicy from "./pages/PrivacyPolicy";
// import TermsOfService from "./pages/TermsOfService";
// import RefundPolicy from "./pages/RefundPolicy";
// import ForgotPassword from "./pages/ForgotPassword";
// import ResetPassword from "./pages/ResetPassword";

import Home from "../pages/Home";
import Pricing from "../pages/Pricing";
import Login from "../pages/Login";
import Signup from "../pages/Signup";
import Dashboard from "../pages/Dashboard";
import Purchase from "../pages/Purchase";
import FAQ from "../pages/FAQ";
import NotFound from "../pages/NotFound";
import CourseContent from "../pages/CourseContent";
import Admin from "../pages/Admin";
import About from "../pages/About";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import RefundPolicy from "../pages/RefundPolicy";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import { useAuth } from "@/contexts/MyContext";

const Allroutes = () => {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {user?.isAdmin !== true ? (
        <>
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/purchase/:id" element={<Purchase />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/course/:moduleId/:itemId" element={<CourseContent />} />
        </>
      ) : (
        <Route path="/admin" element={<Admin />} />
      )}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Allroutes;
